﻿import { GetEntityId } from './entity';
import { getCorporateChartFunc } from './chart';
import { alertWarning, loadingDialog, messageDialog } from '../common/dialogs';
import bootbox from 'bootbox';

export function GetCompanyId() {
    var urlPath = window.location.pathname;
    var arrUrlPath = urlPath.split("/");
    var SelectCompanyIndex = arrUrlPath[3];

    if (!$.isNumeric(SelectCompanyIndex)) {
        SelectCompanyIndex = 0;
    }

    return SelectCompanyIndex;
}

export function AddCompany_OLD() {
    getCorporateChartFunc('corporate-graph').empty();

    var message = $('<div id="new-company-message" />');

    message.append('<label style="font-weight: normal;">Create a completely new analysis </label>');
    message.append('<input type="text" class="form-control input-sm" placeholder="..Input name.." />');
    
    $.ajax({
        url: Router.action('Portfolio', 'ImportNewCompanyData', { area: 'Corp' }),
        method: 'GET',
        success: function (data) {
            var prop;
            var propCount = 0;

            for(prop in data){
                propCount = propCount+1;
            }                      

            if(propCount>0){
                message.append('<hr />');
                message.append('<label style="font-weight: normal;">Alternative 2) Create a new analysis from an Introductory example or Template</label>');

                var dropdown = $('<select class="form-control input-sm" placeholder="import data" />');
                dropdown.append(new Option('..select an Introductory example or a Template..', 0)); 
                dropdown.append(data.map(function (elem) {
                    return new Option(elem.text, elem.id);
                }));
                message.append(dropdown);
                message.append('<br />');

                var commentTextBox = $('<div id="CompanyComment" style="max-height: 100px; overflow: auto;"></div>');
                message.append(commentTextBox);
            }


            var dialog = bootbox.dialog({
                title: 'Create a new analysis',
                message: message,
                buttons: {
                    Add: {
                        label: 'Create',
                        className: 'btn-primary',
                        callback: function () {
                            newCompany($(dialog).find('input').val(), $(dropdown).val());
                        }
                    },
                    Cancel: {
                        label: "Cancel",
                        className: "btn-default",
                        callback: function () {
                            location = "/";
                        }
                    }
                }
            });
        },
        complete: function (e, xhr, settings) {
            if (e.status !== 200) {
                var dialog = bootbox.dialog({
                    title: 'Create company',
                    message: message,
                    buttons: {
                        Add: {
                            label: 'Create',
                            className: 'btn-primary',
                            callback: function () {
                                newCompany($(dialog).find('input').val());
                            }
                        },
                        Cancel: {
                            label: "Cancel",
                            className: "btn-default",
                            callback: function () {
                            }
                        }

                    }
                });
            }
        }
    });
}

const wizardTitles = {
    //'1': 'Step 1 - How would you like to start?',
    //'2': 'Step 2 - Please name your analysis',
    //'3_empty': 'Step 3 - Please select a forecast input type',
    //'3_template': 'Step 3 - Please select a template',
    //'4': 'Step 4 - Select period type',
    //'5': 'Step 5 - How would you like to proceed?',
    //'6_forecast': 'Step 6 - What are the expected/forecasted revenues?',
    //'6_historic': 'Step 6 - Product/service name',
    //'7': 'Step 7 - What are the expected/forecasted costs?'

    '1': 'Please name your analysis',
    '2': 'Empty analysis or using a template?',
    '3_empty': 'Please select a forecast input type',
    '3_template': 'Please select a template',
    '4': 'Select period type',
    '5': 'How would you like to proceed?',
    '6_forecast': 'What are the expected/forecasted revenues?',
    '6_historic': 'Product/service name',
    '7': 'What are the expected/forecasted costs?'

};

function updateWizardTitle(step) {
    var title = wizardTitles[step] || '';
    $(".modal-header > .modal-title").text(title);
}

function loadWizardStep(step, extraData) {
    updateWizardTitle(step);
    var query = '';
    if (extraData && extraData.length > 0) {
        query = '?' + extraData;
    }

    $("#new-analysis-wizard").load('/WizardSteps/Step' + step + query);

    if (step === '1') {

        // NOTE! Fix to show/hide the finish button is instead fix with js code on the Step1.cshtml
        // BUT ! How do I know which js code is run first?

        // The below 'if' does not seem to work :(.... can I fix?
        //var Step1BankCustomerAccess = parseInt($("#Step1BankCustomerAccess").val());  
        //alert(Step1BankCustomerAccess)

        //if (Step1BankCustomerAccess > 0) {
            $(".wizard-dialog-finish-button").show(); // Show Finish button only in Step 1 - If specific InputType as a.g. BakCustomerAccess == 1.. ? ?
        //}
        //else {
        //    $(".wizard-dialog-finish-button").hide();
        //}


        $(".wizard-dialog-next-button").removeClass("btn-primary"); 
        $(".wizard-dialog-back-button").hide();
        //var emptySelected = $('input[name="step1_type"][value="step1_empty_analysis"]').is(':checked');
        //var templateSelected = $('input[name="step1_type"][value="step1_from_template"]').is(':checked');

        //// If neither option is selected, select "empty analysis" by default
        //if (!emptySelected && !templateSelected) {
        //    $('input[name="step1_type"][value="step1_empty_analysis"]').prop("checked", true);
        //}
    } else {
        $(".wizard-dialog-finish-button").hide(); // Hide in all other steps
        $(".wizard-dialog-back-button").show();
        $(".wizard-dialog-next-button").addClass("btn-primary"); 
    }
    //if (step === '2')
    //{
    //    var emptySelected = $('input[name="step1_type"][value="step1_empty_analysis"]').is(':checked');
    //    var templateSelected = $('input[name="step1_type"][value="step1_from_template"]').is(':checked');

    //    // If neither option is selected, select "empty analysis" by default
    //    if (!emptySelected && !templateSelected) {
    //        $('input[name="step1_type"][value="step1_empty_analysis"]').prop("checked", true);
    //    }
    //}
}


// Idea below: Instead of redirect to historical data we simply send the User to the Forecast/Statements free tab directly?
// of the BalanceSheet tab in order to avoid checking Forecast/Statements
export function AddCompany() {
    getCorporateChartFunc('corporate-graph').empty();

    var modalContent = '<div id="loading-spinner" style="text-align: center" hidden>\
                            <p id="output-info-first-line">Please wait for a moment while we create and calculate your analysis</p>\
                            <br />\
                            <p id="output-info" hidden>After this window has been closed you can select output in the top-left drop down lists</p>\
                            <br />\
                            <p id="historic-redirect" hidden>You will be redirected to the screen with historic data input</p>\
                            <br />\
                            <img src="/Content/images/ajax-spinner.gif" width="64px" height="64px" />\
                        </div>\
                        <div id="new-analysis-wizard"></div>\
                        <div id="wizard-error" hidden>\
                        <p id="wizard-error-text"></p>\
                        </div>';
    var step = '1';

    var wizardData = {
        wizardType: undefined,
        inputType: undefined,
        templateId: undefined,
        showProductName: false,
        volumeLabel: undefined,
        companyName: undefined,
        isNewBankClient: false,
        orgNr: undefined,
        clientName: undefined,
        periodType: undefined,
        numberOfPeriods: undefined,
        firstPeriod: undefined,
        firstSalePeriod: undefined,
        firstSaleVolume: undefined,
        lastSaleVolume: undefined,
        firstSalePrice: undefined,
        lastSalePrice: undefined,
        firstSaleRevenue: undefined,
        lastSaleRevenue: undefined,
        firstPeriodFixedCost: undefined,
        firstSaleVariableCost: undefined,
        lastSaleFixedCost: undefined,
        lastSaleVariableCost: undefined,
        skipExpectedValues: undefined,
        firstPeriod: undefined,
        bankModel: false
    };

    var extraData = '';
    var errorState = false;
    var calculationError = false;
    var newCompanyId = 0;

    function takeIntFromField(fieldSelector) {
        var value = parseInt($(fieldSelector).val());
        if (isNaN(value)) value = 0;
        return value;
    }

    function takeFloatFromField(fieldSelector) {
        var value = parseFloat($(fieldSelector).val());
        if (isNaN(value)) value = 0;
        return value;
    }

    function redirectWithTimeout(newLocation, timeout = 5000) {
        setTimeout(function () { location = newLocation; }, timeout);
    }

    function wizardError(message, calcError = false) {
        $(".bootbox-button").attr("disabled", false);
        $("#wizard-error").show();
        $("#wizard-error-text").text(message);
        $("#loading-spinner").hide();
        $("#new-analysis-wizard").hide();

        var nextButtonText = "Try again";
        if (calcError) {
            nextButtonText = "Ok";
            $(".wizard-dialog-cancel-button").hide();
        }
        $(".wizard-dialog-next-button").text(nextButtonText);
        $(".wizard-dialog-back-button").hide();
        $(".wizard-dialog-cancel-button").text("Close");

        errorState = true;
        calculationError = calcError;
    }

    function showWaitingScreen() {
        $("#loading-spinner").show();
        $("#new-analysis-wizard").hide();
        $(".bootbox-button").attr("disabled", "disabled");
        updateWizardTitle("");

        var startTimestamp = Date.now();
        $.ajax({
            url: Router.action('Portfolio', 'CreateCompany', { area: 'Corp' }),
            method: "POST",
            data: { WizardDataJson: JSON.stringify(wizardData) },
            success: function (data) {
                if (data && data.ok === true && data.NewCompanyId) {
                   
                    if (wizardData.skipExpectedValues) {

                        //redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/HistoricStatement");
                        redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/BalanceSheet");

                    } else if (!wizardData.bankModel) {
                        newCompanyId = data.NewCompanyId;
                        if (wizardData.inputType === 0) {
                            $("#output-info").hide();
                            $("#output-info-first-line").text("Please wait for a moment while we create your analysis");
                        } else {
                            $("#output-info").show();
                        }
                        
                        $.ajax({
                            url: Router.action("Portfolio", "CalculateCompany", { area: "Corp" }),
                            data: { CompanyId: data.NewCompanyId },
                            method: "GET",
                            success: function () {
                                var endTimestamp = Date.now();
                                var diff = endTimestamp - startTimestamp;
                                if (diff > 5000) {
                                    diff = 0;
                                } else {
                                    if (diff < 0) diff = 0;
                                    diff = 5000 - diff;
                                }
                                redirectWithTimeout("/Corp/l/" + data.NewCompanyId, diff);
                            },
                            error: function () {
                                // This error appear on the WWW ! ! ! 
                                wizardError("Failed to calculate! Try to calculate manually", true);
                            }
                        });
                    } else {
                        redirectWithTimeout("/Corp/l/" + data.NewCompanyId);
                    }
                } else if (data && data.ok === false && data.message) {
                    wizardError(data.message);
                } else {
                    wizardError("Failed to create a new company! Please try again w 1");
                }
            },
            error: function () {
                wizardError("Failed to create a new company! Please try again w 2");
            }
        });
    }

    bootbox.dialog({
        title: 'New analysis wizard',
        closeButton: false,

        //width: "100%", // Does not work
        //size: 'large',    // works
        size: 'medium',

        message: modalContent,
        buttons: {
            Cancel: {
                label: 'Cancel',
                className: 'bootbox-button wizard-dialog-cancel-button',
                callback: function () {
                    location = '/';
                }
            },
            Back: {
                label: "Back",
                className: "btn-default wizard-dialog-back-button bootbox-button",
                callback: function () {
                    if (step === '2') {
                        extraData = 'WizardType=' + wizardData.wizardType;
                        step = '1';
                    } else if (step === '3_empty' || step === '3_template') {
                        if (wizardData.companyName) extraData = 'Name=' + encodeURIComponent(wizardData.companyName);
                        var haveTemplates = $("#template-selection").length;
                        var templateSelected = haveTemplates && $("#template-selection").val() > 0;
                        if (templateSelected) {
                            wizardData.templateId = parseInt($("#template-selection").val());
                        }
                        $(".wizard-dialog-next-button").text("Next");
                        step = '2';
                    } else if (step === '4') {
                        step = '3_' + wizardData.wizardType;
                        if (wizardData.inputType && wizardData.wizardType === 'empty') extraData = 'InputType=' + wizardData.inputType;
                        if (wizardData.templateId && wizardData.wizardType === 'template') extraData = 'TemplateId=' + wizardData.templateId;
                        $(".wizard-dialog-next-button").text("Next");
                    } else if (step === '5') {
                        var dataType = $('input[name="step5_type"]:checked').val();
                        if (dataType === 'step5_empty') {
                            wizardData.skipExpectedValues = false;
                        } else {
                            wizardData.skipExpectedValues = true;
                        }
                        extraData = 'InputType=' + wizardData.inputType + '&';
                        if (wizardData.periodType) extraData += 'PeriodType=' + wizardData.periodType + '&';
                        if (wizardData.numberOfPeriods) extraData += 'NumPeriods=' + wizardData.numberOfPeriods + '&';
                        if (wizardData.firstPeriod) extraData += 'PeriodStart=' + wizardData.firstPeriod;


                        $(".wizard-dialog-next-button").text("Next");
                        step = '4';
                    } else if (step === '6_forecast') {
                        extraData = 'InputType=' + wizardData.inputType + '&ShowProductName=' + wizardData.showProductName;
                        if (wizardData.skipExpectedValues !== undefined) extraData += '&HistoricDataSelected=' + wizardData.skipExpectedValues;
                        step = '5';
                    } else if (step === '6_historic') {
                        wizardData.volumeLabel = $("#product-name").val().trim();
                        if (!wizardData.volumeLabel) {
                            wizardData.volumeLabel = $("#product-name").attr("placeholder");
                        }
                        extraData = 'InputType=' + wizardData.inputType + '&ShowProductName=' + wizardData.showProductName;
                        if (wizardData.skipExpectedValues !== undefined) extraData += '&HistoricDataSelected=' + wizardData.skipExpectedValues;
                        step = '5';
                    } else if (step === '7') {
                        $(".wizard-dialog-next-button").text("Next");
                        extraData = 'NumberOfPeriods=' + wizardData.numberOfPeriods + '&ShowProductName=' + wizardData.showProductName + '&';
                        if (wizardData.volumeLabel) extraData += 'VolumeLabel=' + encodeURIComponent(wizardData.volumeLabel) + '&';
                        if (wizardData.firstSalePeriod) extraData += 'SelectedFirstPeriod=' + wizardData.firstSalePeriod + '&';
                        if (wizardData.firstSaleVolume) extraData += 'FirstSaleVolume=' + wizardData.firstSaleVolume + '&';
                        if (wizardData.lastSaleVolume) extraData += 'LastSaleVolume=' + wizardData.lastSaleVolume + '&';
                        if (wizardData.firstSalePrice) extraData += 'FirstSalePrice=' + wizardData.firstSalePrice + '&';
                        if (wizardData.lastSalePrice) extraData += 'LastSalePrice=' + wizardData.lastSalePrice + '&';
                        if (wizardData.firstSaleRevenue) extraData += 'FirstSaleRevenue=' + wizardData.firstSaleRevenue + '&';
                        if (wizardData.lastSaleRevenue) extraData += 'LastSaleRevenue=' + wizardData.lastSaleRevenue;

                        wizardData.firstPeriodFixedCost = takeFloatFromField("#first-period-fixed-cost");
                        wizardData.firstSaleVariableCost = takeFloatFromField("#first-sale-variable-cost");
                        wizardData.lastSaleFixedCost = takeFloatFromField("#last-sale-fixed-cost");
                        wizardData.lastSaleVariableCost = takeFloatFromField("#last-sale-variable-cost");
                        step = '6_forecast';
                    }
                    loadWizardStep(step, extraData);
                    extraData = '';
                    return false;
                }
            },
            Next: {
                label: 'Next',
                className: 'btn-primary wizard-dialog-next-button bootbox-button',
                callback: function () {
                    if (errorState) {
                        if (calculationError) {
                            location = "/Corp/l/" + newCompanyId;
                        } else {
                            location = "/Corp/l?NewCompany=True";
                        }
                        return false;
                    }

                    if (step === '1') {


                        // Note! Have js code on the Step1.cshtml


                        if ($("#bank-customer-type").length > 0) {
                            wizardData.isNewBankClient = $("#bank-customer-type").val() === "new";
                            if (wizardData.isNewBankClient) {
                                wizardData.orgNr = $("#org-nr").val().trim();
                                wizardData.clientName = $("#client-name").val().trim();
                                if (!wizardData.orgNr || !wizardData.clientName) {
                                    alert("Please fill in the org nr and client name");
                                    return false;
                                }
                            }
                        }

                        wizardData.companyName = $("#company-name").val().trim();
                        if (!wizardData.companyName) {
                            wizardData.companyName = $("#company-name").attr("placeholder");
                        }
                        //var newAnalysisType = $('input[name="step1_type"]:checked').val();
                        //if (newAnalysisType === 'step1_empty_analysis') {
                        //    wizardData.wizardType = 'empty';
                        //} else {
                        //    wizardData.wizardType = 'template';
                        //}



                        if (wizardData.companyName) extraData = 'Name=' + encodeURIComponent(wizardData.companyName);

                        step = '2';
                    }
                    else if (step === '2') {
                        //wizardData.companyName = $("#company-name").val().trim();
                        //if (!wizardData.companyName) {
                        //    wizardData.companyName = $("#company-name").attr("placeholder");
                        //}
                        var newAnalysisType = $('input[name="step1_type"]:checked').val();
                        //$('input[name="step1_type"]').first().prop("checked", true);
                        if (newAnalysisType === 'step1_empty_analysis') {
                            wizardData.wizardType = 'empty';
                        } else {
                            wizardData.wizardType = 'template';
                        }
                        if (wizardData.inputType && wizardData.wizardType === 'empty') extraData = 'InputType=' + wizardData.inputType;
                        if (wizardData.templateId && wizardData.wizardType === 'template') extraData = 'TemplateId=' + wizardData.templateId;
                        step = '3_' + wizardData.wizardType;
                        if (wizardData.wizardType === 'template') {
                            $(".wizard-dialog-next-button").text("Create analysis");
                        }
                    }
                    else if (step === '3_empty') {

                        if ($("#input-type").length > 0)
                        {
                            var inputType = parseInt($("#input-type").val());

                            if (inputType < 16)
                            {
                                // Part 1) 
                                // alt a) The generic alternative
                                if ([3, 10, 8, 12, 14].indexOf(inputType) != -1) {
                                    wizardData.showProductName = true;
                                } else {
                                    wizardData.showProductName = false;
                                }
                                wizardData.inputType = inputType;
                                wizardData.bankModel = false;


                                // Part 2) if 'Advanced' input type is selected, then skip step 5+
                                // NOTE! Later when Create Forecast from Historical data is working, then must avllow that! 
                                if (wizardData.inputType == 7 || wizardData.inputType == 11 || wizardData.inputType == 8 || wizardData.inputType == 12 || wizardData.inputType == 13 || wizardData.inputType == 14) {
                                    $(".wizard-dialog-next-button").text("Create analysis");           // It changes the text 
                                }

                            }
                            else
                            {
                                // alt b) Specific model alternatives ... also come here if selected any of the CRE models..
                                //ïf(inputType > 19){
                                //}
                                wizardData.inputType = inputType;
                                wizardData.showProductName = false;
                                $(".wizard-dialog-next-button").text("Create analysis");           // It changes the text, but does not send the User to the end, ie. ends the wizard
                            }        
                        }
                        else
                        {
                            // Come here if not Input types in the '' ddl.... BUT/AND Frank has also set this DDL to contain no input if the Commodity Model                          

                            wizardData.showProductName = true;
                            
                            wizardData.inputType = 14;
                            wizardData.bankModel = true;
                            $(".wizard-dialog-next-button").text("Create analysis");
                        }

                        extraData = 'InputType=' + inputType + '&';
                        if (wizardData.periodType) extraData += 'PeriodType=' + wizardData.periodType + '&';
                        if (wizardData.numberOfPeriods) extraData += 'NumPeriods=' + wizardData.numberOfPeriods + '&';
                        if (wizardData.firstPeriod) extraData += 'PeriodStart=' + wizardData.firstPeriod;

                        step = '4';
                        if (inputType == 0) {
                            showWaitingScreen();
                            return false;
                        }


                    }
                    else if (step === '3_template') {
                        var haveTemplates = $("#template-selection").length;
                        var templateSelected = haveTemplates && $("#template-selection").val() > 0;
                        if (templateSelected) {
                            wizardData.templateId = parseInt($("#template-selection").val());
                            step = '4';
                            showWaitingScreen();
                            return false;
                        } else if (!haveTemplates) {
                            step = '1';
                        } else if (haveTemplates) {
                            $("#template-selection-warning").show();
                            return false;
                        }
                    }
                    else if (step === '4') {

                        // We also have js code on Step4.cshtml

                        wizardData.periodType = parseInt($("#period-type").val());
                        wizardData.numberOfPeriods = parseInt($("#number-of-periods").val());
                        wizardData.firstPeriod = parseInt($('select[data-content="first-period"]:visible').val());

                        // inputType == 30 - BankCustomer analysis
                        if (wizardData.bankModel || wizardData.inputType == 30) {
                            //$(".wizard-dialog-next-button").text("Create analysis");           // It changes the text ?? NO! the code above does that
                            // alert("Frank")    // Note this alert is triggered when click the Finish/Create analysis bottom right button
                            showWaitingScreen();
                            return false;
                        }

                        // Frank 2023 03 09 ...if CRE
                        //if (wizardData.inputType == 20 || inputType == 20 || inputType == 21 || inputType == 22) {
                        if (wizardData.inputType == 20 || wizardData.inputType == 21 || wizardData.inputType == 22) {
                            showWaitingScreen();
                            return false;
                        }

                        // Frank 2026 04 06 - We skip the rest of the Steps if an 'Advanced input type'
                        // .. that is, only the basic input types .. check 'Step3_empty.cshtml'
                        // NOTE! LATER! When create Forecast from Historical data is working then allow the next .. Step 5 ! ! !
                        if (wizardData.inputType == 7 || wizardData.inputType == 11 || wizardData.inputType == 8 || wizardData.inputType == 12 || wizardData.inputType == 13 || wizardData.inputType == 14) {
                            // $(".wizard-dialog-next-button").text("Create analysis");           // It changes the text ?? NO it does not... code further above does

                            showWaitingScreen();
                            return false;
                        }


                        extraData += 'InputType=' + wizardData.inputType + '&ShowProductName=' + wizardData.showProductName;
                        if (wizardData.skipExpectedValues !== undefined) extraData += '&HistoricDataSelected=' + wizardData.skipExpectedValues;
                        step = '5';
                    } else if (step === '5') {
                        var dataType = $('input[name="step5_type"]:checked').val();
                        if (dataType === 'step5_empty') {
                            wizardData.skipExpectedValues = false;

                            extraData = 'NumberOfPeriods=' + wizardData.numberOfPeriods + '&ShowProductName=' + wizardData.showProductName + '&';
                            if (wizardData.volumeLabel) extraData += 'VolumeLabel=' + encodeURIComponent(wizardData.volumeLabel) + '&';
                            if (wizardData.firstSalePeriod) extraData += 'SelectedFirstPeriod=' + wizardData.firstSalePeriod + '&';
                            if (wizardData.firstSaleVolume) extraData += 'FirstSaleVolume=' + wizardData.firstSaleVolume + '&';
                            if (wizardData.lastSaleVolume) extraData += 'LastSaleVolume=' + wizardData.lastSaleVolume + '&';
                            if (wizardData.firstSalePrice) extraData += 'FirstSalePrice=' + wizardData.firstSalePrice + '&';
                            if (wizardData.lastSalePrice) extraData += 'LastSalePrice=' + wizardData.lastSalePrice + '&';
                            if (wizardData.firstSaleRevenue) extraData += 'FirstSaleRevenue=' + wizardData.firstSaleRevenue + '&';
                            if (wizardData.lastSaleRevenue) extraData += 'LastSaleRevenue=' + wizardData.lastSaleRevenue;
                            step = '6_forecast';
                        } else if (wizardData.showProductName) {
                            wizardData.skipExpectedValues = true;
                            step = '6_historic';
                            if (wizardData.volumeLabel) extraData = 'VolumeLabel=' + encodeURIComponent(wizardData.volumeLabel);
                            $(".wizard-dialog-next-button").text("Create analysis");
                        } else {
                            wizardData.skipExpectedValues = true;
                            showWaitingScreen();
                            $("#historic-redirect").show();
                            $("#output-data").hide();
                            return false;
                        }
                    } else if (step === '6_forecast') {
                        wizardData.firstSalePeriod = takeIntFromField("#first-sale-period");

                        if (wizardData.showProductName) {
                            wizardData.volumeLabel = $("#product-name").val().trim();
                            if (!wizardData.volumeLabel) {
                                wizardData.volumeLabel = $("#product-name").attr("placeholder");
                            }

                            wizardData.firstSaleVolume = takeFloatFromField("#first-sale-volume");
                            wizardData.lastSaleVolume = takeFloatFromField("#last-sale-volume");
                            wizardData.firstSalePrice = takeFloatFromField("#first-sale-price");
                            wizardData.lastSalePrice = takeFloatFromField("#last-sale-price");
                        } else {
                            wizardData.firstSaleRevenue = takeFloatFromField("#first-sale-revenue");
                            wizardData.lastSaleRevenue = takeFloatFromField("#last-sale-revenue");
                        }
                        $(".wizard-dialog-next-button").text("Create analaysis");
                        extraData = 'FirstSalePeriod=' + wizardData.firstSalePeriod + '&LastSalePeriod=' + wizardData.numberOfPeriods + '&';
                        if (wizardData.firstSaleVariableCost) extraData += 'FirstVariableCost=' + wizardData.firstSaleVariableCost + '&';
                        if (wizardData.lastSaleVariableCost) extraData += 'LastVariableCost=' + wizardData.lastSaleVariableCost + '&';
                        if (wizardData.firstPeriodFixedCost) extraData += 'FirstFixedCost=' + wizardData.firstPeriodFixedCost + '&';
                        if (wizardData.lastSaleFixedCost) extraData += 'LastFixedCost=' + wizardData.lastSaleFixedCost + '&';
                        if (wizardData.showProductName) extraData += 'ShowProductName=' + wizardData.showProductName + '&';
                        if (wizardData.volumeLabel) extraData += 'VolumeLabel=' + encodeURIComponent(wizardData.volumeLabel) + '&';
                        if (wizardData.inputType) extraData += 'InputType=' + wizardData.inputType;


                        step = '7';
                    } else if (step === '6_historic') {
                        wizardData.volumeLabel = $("#product-name").val().trim();
                        if (!wizardData.volumeLabel) {
                            wizardData.volumeLabel = $("#product-name").attr("placeholder");
                        }
                        showWaitingScreen();
                        $("#historic-redirect").show();
                        $("#output-data").hide();
                        return false;
                    } else if (step === '7') {
                        wizardData.firstPeriodFixedCost = takeFloatFromField("#first-period-fixed-cost");
                        wizardData.firstSaleVariableCost = takeFloatFromField("#first-sale-variable-cost");
                        wizardData.lastSaleFixedCost = takeFloatFromField("#last-sale-fixed-cost");
                        wizardData.lastSaleVariableCost = takeFloatFromField("#last-sale-variable-cost");

                        showWaitingScreen();
                        return false;
                    }
                    loadWizardStep(step, extraData);
                    extraData = '';
                    return false;
                }
            },
            Finish: {
                label: 'Create analysis',
                className: 'btn-primary wizard-dialog-finish-button',
                callback: function () {
                    var isNewBankClient = $("#bank-customer-type").length > 0 && $("#bank-customer-type").val() === "new";
                    var orgNr;
                    var clientName;

                    if (isNewBankClient) {
                        orgNr = $("#org-nr").val().trim();
                        clientName = $("#client-name").val().trim();
                        if (!orgNr || !clientName) {
                            alert("Please fill in the org nr and client name");
                            return false;
                        }
                    }

                    var wizardCompanyName = $("#company-name").val().trim() || $("#company-name").attr("placeholder");

                    //Here we can have fixed default values
                    let wizardData = {
                        inputType: 30,
                        bankModel: false,
                        companyName: wizardCompanyName,
                        isNewBankClient: isNewBankClient,
                        orgNr: orgNr,
                        clientName: clientName,
                        wizardType: "empty",
                        showProductName: false,
                        periodType: 1,
                        numberOfPeriods: 10,
                        firstPeriod: 0

                    };
                    // Assign required default values

                    function submitCreateCompany() {
                    var startTimestamp = Date.now();
                    $.ajax({
                        url: Router.action('Portfolio', 'CreateCompany', { area: 'Corp' }),
                        method: "POST",
                        data: { WizardDataJson: JSON.stringify(wizardData) },
                        success: function (data) {
                            if (data && data.ok === true && data.NewCompanyId) {

                                if (wizardData.skipExpectedValues) {

                                    // Old, original, when sent to HistoricStatement
                                    //redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/HistoricStatement");

                                    //redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/BalanceSheet");        // I would send to ForecastPeriodic/StatementsFree if I knew which of them to send to
                                    if (wizardData.inputType < 13) {
                                        redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/StatementsFree"); 
                                    }
                                    else {
                                        redirectWithTimeout("/Corp/l/" + data.NewCompanyId + "/0/ForecastPeriodic"); 
                                    }

                                } else if (!wizardData.bankModel) {
                                    newCompanyId = data.NewCompanyId;
                                    if (wizardData.inputType === 0) {
                                        $("#output-info").hide();
                                        $("#output-info-first-line").text("Please wait for a moment while we create your analysis");
                                    } else {
                                        $("#output-info").show();
                                    }

                                    $.ajax({
                                        url: Router.action("Portfolio", "CalculateCompany", { area: "Corp" }),
                                        data: { CompanyId: data.NewCompanyId },
                                        method: "GET",
                                        success: function () {
                                            var endTimestamp = Date.now();
                                            var diff = endTimestamp - startTimestamp;
                                            if (diff > 5000) {
                                                diff = 0;
                                            } else {
                                                if (diff < 0) diff = 0;
                                                diff = 5000 - diff;
                                            }
                                            redirectWithTimeout("/Corp/l/" + data.NewCompanyId, diff);
                                        },
                                        error: function () {
                                            // This error appear on the WWW ! ! ! 
                                            wizardError("Failed to calculate! Try to calculate manually", true);
                                        }
                                    });
                                } else {
                                    redirectWithTimeout("/Corp/l/" + data.NewCompanyId);
                                }
                            } else if (data && data.ok === false && data.message) {
                                wizardError(data.message);
                            } else {
                                wizardError("Failed to create a new company! Please try again w 1");
                            }
                        },
                        error: function () {
                            wizardError("Failed to create a new company! Please try again w 2");
                        }
                    });
                    }

                    if (isNewBankClient) {
                        // Save the bank client to OPGBankCustomer first (same immediate-save behaviour as the old '+' add-company
                        // button), then create the analysis once it's confirmed saved.
                        $.ajax({
                            url: Router.action('WizardSteps', 'SaveBankCustomer'),
                            method: "POST",
                            data: { OrgNr: orgNr, ClientName: clientName },
                            success: function (data) {
                                if (data && data.ok === true) {
                                    submitCreateCompany();
                                } else {
                                    wizardError((data && data.message) || "Failed to save the bank client! Please try again");
                                }
                            },
                            error: function () {
                                wizardError("Failed to save the bank client! Please try again");
                            }
                        });
                    } else {
                        submitCreateCompany();
                    }
                }
            }
        }
    });

    loadWizardStep(step);
 
}








export function AddCompanyToDDL(companyId, companyName, comment, access) {
    // Add divider
    $("#select-company ul").append(
        $('<li>').addClass('divider').attr('role', 'separator'));

    // Add company
    $("#select-company ul").append(
        $('<li>').addClass('company-item').attr('value', companyId).append(
            $('<a>').attr('href', '#').append(
                $('<span>').addClass('company-name-span').append(companyName),
                $('<span>').addClass('company-model-name-span').append(comment == "Owner" ? comment : access)
            )));

}

function newCompany(name, id) {
    var data;

    if (id !== null) {
        data = { name: name, ImportId: id, CompanyId: GetCompanyId(), EntityId: GetEntityId() };
    } else {
        data = { name: name, CompanyId: GetCompanyId(), EntityId: GetEntityId() };
    }

    loadingDialog('.body-overlay', 1000, 1000, 1, null, 'Creating company...', null, null, null, function (callback) {
        $.ajax({
            url: Router.action('Portfolio', 'CreateCompany', { area: 'Corp' }),
            method: 'POST',
            data: data,
            statusCode: {
                200: function (response, status, error) {
                    $.ajax({
                        url: Router.action("Portfolio", "GetCompanyIdNewlyCreatedCompany", { area: "Corp" }),
                        method: "GET",
                        data: { NewCompanyName: name},
                        success: function (data) {
                            location = "/Corp/l/" + data.NewCompanyId + "/0#";
                        }
                    });
                },
                500: function (response, status, error) {
                    messageDialog('Error', error);
                }
            },
            complete: function () {
                if (typeof (callback) === 'function') {
                    callback();
                }
            }
        });
    });
}

